import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Acc-Page-hd-Icon" }
const _hoisted_2 = { class: "Acc-Page-hd-Cont" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Acc-Page-hd", _ctx.padded ? 'isPadded' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ])
  ], 2))
}